var fn = function( obj ){
var __t,__p='';
__p+='\n\nuniform sampler2D uTex;\n\nuniform vec3 uTint;\n\n\nvoid main( void ){\n\n\n  vec3 color = texture2D(uTex, gl_PointCoord).rgb * uTint;\n  gl_FragColor = vec4( color, 1.0);\n\n}';
return __p;
};
fn.toString=fn;
module.exports = fn;